// Add elements and classes to print link from Entity Print module.
const printLink = document.querySelector('a.print__link');

if (printLink) {
  printLink.setAttribute('target', '_blank');
}
